module.exports = __webpack_public_path__ + "static/media/Item 12.3d22a38b.jpg";